var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfBuildersHouseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 78,
    viewBox: "0 0 93 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8262 18.1172L81.5039 48.0654L81.6768 48.2158V77.3174H12.1094V46.6348L12.2881 46.4844L46.1787 18.1113L46.5039 17.8389L46.8262 18.1172ZM35.4648 49.2324V69.7246H57.5332V49.2324H35.4648Z",
    fill: "#F85757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 10.2458L4.72881 44.9237L0 40.1949L46.5 0L67.7797 18.9153V7.09322H77.2373V26.7966L93 40.1949L88.2712 44.9237L46.5 10.2458Z",
    fill: "#F85757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfBuildersHouseLogo);
export default __webpack_public_path__ + "static/media/Self-builders-house-logo.c9d560a3750894315de1f51a0b36f2a8.svg";
export { ForwardRef as ReactComponent };